export default {
  set(state, { data }) {
    state.variants = data;
  },
  show(state, { data }) {
    state.variant = data;
  }
}